import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, LabelL } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import { PackRotationAt } from 'components/commonCard/BuyPacks/PackRotationAt';

import type { DailyDealsTitle_cardPackGroup } from './__generated__/index.graphql';

export const DailyDealsTitle = ({
  cardPackGroup,
}: {
  cardPackGroup: Nullable<DailyDealsTitle_cardPackGroup>;
}) => {
  return (
    <Vertical gap={0.5}>
      <Horizontal>
        <BrandM>
          <FormattedMessage {...glossary.dailyDeals} />
        </BrandM>
        <PackRotationAt cardPackGroup={cardPackGroup} />
      </Horizontal>
      <LabelL
        className="text-gradient-color"
        style={
          {
            '--text-gradient-color': 'var(--c-gradient-gold)',
          } as CSSProperties
        }
      >
        <FormattedMessage
          id="commonCard.DailyDeals.exclusivePacks"
          defaultMessage="Exclusive Packs"
        />
      </LabelL>
    </Vertical>
  );
};

DailyDealsTitle.fragments = {
  cardPackGroup: gql`
    fragment DailyDealsTitle_cardPackGroup on CardPackGroup {
      id
      ...PackRotationAt_cardPackGroup
    }
    ${PackRotationAt.fragments.cardPackGroup}
  ` as TypedDocumentNode<DailyDealsTitle_cardPackGroup>,
};
